// services/exerciseResultService.js
import { create, getAll, getById, update, remove, customFetch } from './baseService';

const endpoint = 'exercise-results';

const exerciseResultService = {
  // Lấy tất cả kết quả bài tập
  getAll: async (params) => {
    return getAll(endpoint, params);
  },

  // Lấy kết quả bài tập theo ID
  getById: async (id) => {
    return getById(endpoint, id);
  },

  // Lấy kết quả bài tập của cá nhân theo exerciseId
  getMyResultByExerciseId: async (id) => {
    return getById(`${endpoint}/getMe/exercise`, id);
  },

  // Tạo kết quả bài tập mới
  create: async (data) => {
    return create(endpoint, data);
  },

  // Cập nhật kết quả bài tập
  update: async (id, data) => {
    return update(endpoint, id, data);
  },

  // Xóa kết quả bài tập
  delete: async (id) => {
    return remove(endpoint, id);
  },

  // Tính điểm cho bài tập
  scoreExercise: async (data) => {
    return customFetch(`${endpoint}/score`, {
      method: 'POST',
      body: data,
    });
  },
  // Tính điểm cho bài tập viết
  scoreExerciseWriting: async (data) => {
    return customFetch(`${endpoint}/scoreWriting`, {
      method: 'POST',
      body: data,
    });
  }
};

export default exerciseResultService;
